<div [class.center-parent]="centerToParent" class="wrapper">
  <div class="lds-ellipsis">
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
  </div>
  <ng-content />
</div>
